import { ZeroAlert } from './alert.model';

export class AddInfoAlert {
  public static readonly type = '[Alert] add info alert';
  constructor(public payload: { alert: ZeroAlert }) {}
}

export class AddSuccessAlert {
  public static readonly type = '[Alert] add success alert';
  constructor(public payload: { alert: ZeroAlert }) {}
}

export class AddErrorAlert {
  public static readonly type = '[Alert] add error alert';
  constructor(public payload: { alert: ZeroAlert }) {}
}

export class ClearAlerts {
  public static readonly type = '[Alert] clear alerts';
}
